import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './components/App';

// Check if sessionStorage is available
const isSessionStorageAvailable = () => {
  try {
    const testKey = 'test';
    window.sessionStorage.setItem(testKey, testKey);
    window.sessionStorage.removeItem(testKey);
    return true;
  } catch (e) {
    console.warn('sessionStorage is not available. Session persistence will be disabled.');
    return false;
  }
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {isSessionStorageAvailable() ? (
      <App />
    ) : (
      <div className="storage-error">
        <h1>Storage Error</h1>
        <p>
          This application requires sessionStorage to function properly.
          Please enable cookies and sessionStorage in your browser settings.
        </p>
      </div>
    )}
  </React.StrictMode>
);

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered with scope:', registration.scope);
      
      // Check if push is supported
      if ('PushManager' in window) {
        console.log('Push notifications are supported');
        
        // Get the application server key from the server
        try {
          const response = await fetch('/api/push/vapid-public-key');
          if (response.ok) {
            const vapidPublicKey = await response.text();
            
            // Convert the VAPID key to the format expected by the browser
            const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
            
            // Send the application server key to the service worker
            if (registration.active) {
              registration.active.postMessage({
                type: 'SET_APPLICATION_SERVER_KEY',
                key: applicationServerKey
              });
              console.log('Application server key sent to service worker');
            }
          } else {
            console.warn('Failed to fetch VAPID public key:', response.statusText);
          }
        } catch (error) {
          console.error('Error fetching VAPID public key:', error);
        }
      } else {
        console.log('Push notifications are not supported');
      }
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  });
}

// Helper function to convert base64 to Uint8Array
// This is needed for the applicationServerKey
function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  
  return outputArray;
}